import React from 'react'
import { useThemeManager } from '../../../../_hooks/useThemeManager'

interface ReasoningStepProps {
  text: string
  status: 'completed' | 'active' | 'pending'
  showLine?: boolean
  isAnimating?: boolean
}

export const ReasoningStep: React.FC<ReasoningStepProps> = ({
  text,
  status,
  showLine = false,
  isAnimating = false
}) => {
  const { isDarkTheme: isDark } = useThemeManager()

  const getMarkerColor = () => {
    switch (status) {
      case 'completed':
        return 'theme-bg-text-subheading'
      case 'active':
        return isDark ? 'theme-surface' : 'theme-bg-text-heading'
      case 'pending':
        return isDark ? 'theme-bg-border' : 'theme-border'
      default:
        return 'theme-border'
    }
  }

  const getTextColor = () => {
    switch (status) {
      case 'completed':
      case 'pending':
        return 'theme-text-subheading'
      case 'active':
        return isDark ? 'text-white' : 'theme-text-heading'
      default:
        return 'theme-text-subheading'
    }
  }

  return (
    <div className="relative" data-testid={`thinking-step-${status}`}>
      {showLine && (
        <div
          data-testid="thinking-step-line"
          className="absolute left-[11px] top-[11px] w-0.5 h-[calc(100%+8px)] z-0 theme-border-default"
        />
      )}
      <div className="flex items-center gap-2 pl-2 relative z-10">
        <div
          data-testid="thinking-step-marker"
          className={`w-2 h-2 rounded-full flex-shrink-0 ${getMarkerColor()} ${
            isAnimating ? 'animate-thinking-pulse' : ''
          }`}
        />
        <span className={`text-sm leading-[1.571em] flex-1 ${getTextColor()}`}>{text}</span>
      </div>
    </div>
  )
}
